<template>
  <v-application v-if="access.setting_loyalty">
    <v-settings>
      <v-toolbar flat>
        <v-toolbar-title>{{ $t("loyalty_settings") }}</v-toolbar-title>
      </v-toolbar>
      <v-form v-model="is_valid">
        <v-card-text>
          <v-text-field
            disabled
            :label="$t('loyalty_type')"
            :value="$t('bonus_system')"
          />
          <v-text-field
            v-model.number="loyalty.loyalty_bonus"
            type="number"
            :label="$t('a_percentage_of_the_purchase_amount')"
            :rules="[fieldRules.requiredNumber]"
          />
        </v-card-text>
      </v-form>
      <template #actions>
        <v-btn text v-on:click="loyalty_cancel">{{ $t("cancel") }}</v-btn>
        <v-btn
          text
          color="primary"
          v-on:click="loyalty_save"
          :disabled="!is_valid"
          :loading="update_loading"
          >{{ $t("save") }}</v-btn
        >
      </template>
    </v-settings>
  </v-application>
  <error404 v-else></error404>
</template>
<script>
import Loyalty from "../../mixins/loyalty";
export default {
  name: "SettingsLoyalty",
  mixins: [Loyalty],
  data: () => ({
    is_valid: false,
    update_loading: false,
  }),
  beforeMount() {
    this.access = this.$store.state.access;
  },
};
</script>